import axios from "axios";
import {getBackendApiBaseUrl} from "./axios"

/*const getBackendApiBaseUrl = () => {
    const hostname = window.location.hostname;
    const path = window.location.pathname;


    if (hostname === 'mbat.chamber.uz') {
        return 'https://mbatbackend.chamber.uz';
    //} else if (hostname === 'localhost'  || (hostname === 'mbatbackend.chamber.uz' && path.startsWith('/test_be')) ) {
    } else if (hostname === 'localhost') {
        return 'https://mbatbackend.chamber.uz/test_be';
    }

    return 'https://mbatbackend.chamber.uz';
};*/

    const requestHeaders = {
        'Content-Type': 'application/json;charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'withCredentials': true
    }

const request = axios.create({
    //baseURL: 'https://mbatbackend.chamber.uz',
    //baseURL: 'https://backend.ssp-mbat.uz',
    //baseURL: 'https://newbackend.ssp-mbat.uz/',
    baseURL: getBackendApiBaseUrl(),
    headers: requestHeaders,
    withCredentials: false
    //baseURL: 'https://mbat.chamber.uz'
    //baseURL: 'http://217.30.161.190:10006'
    //baseURL: 'http://172.24.255.74:9595'
    //baseURL: 'http://95.181.224.113:9595'
    /*baseURL: 'http://10.50.50.145:9797'*/
    //baseURL: 'http://192.168.44.201:8383'
});
request.interceptors.request.use(
    (config) => {
        const {token} = JSON.parse(localStorage.getItem('userData'));
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {

            }
        }
        return Promise.reject(error);
    }
);
export {request}

